import React from "react";
import { Link } from "react-router-dom";
import { Plane, ArrowRight, Tag } from "lucide-react";
import { useContent } from "@/lib/useContent";

export const FlightPromos = () => {
  const promos = useContent("flight_promos");
  if (!promos || promos.length === 0) return null;
  return (
    <section className="py-24 lg:py-28 bg-white" data-testid="flight-promos-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="mk-gold-line mb-6 inline-block" />
          <p className="text-xs uppercase tracking-[0.25em] text-[#D4A62A] font-bold mb-3">Flight Promotions</p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#0A2E4D] tracking-tight leading-tight">This month's best fares</h2>
          <p className="mt-4 text-base text-[#4B5563]">Limited-time fares negotiated with our airline partners. Fares are indicative and subject to availability.</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {promos.map((p, i) => (
            <div key={i} className="mk-card p-7 flex flex-col" data-testid={`flight-promo-${i}`}>
              <div className="flex items-center justify-between">
                <Plane size={22} className="text-[#D4A62A]" strokeWidth={1.5} />
                <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider bg-[#FDF8EC] text-[#BA901D] rounded-full px-2.5 py-1"><Tag size={10} /> Promo</span>
              </div>
              <h3 className="font-serif-display text-xl text-[#0A2E4D] mt-4">{p.route}</h3>
              <p className="text-xs text-[#4B5563] mt-1">{p.airline}{p.cabin ? ` · ${p.cabin}` : ""}</p>
              <div className="mt-5 flex-1">
                <div className="text-[11px] text-[#4B5563] uppercase tracking-wider">Fares From</div>
                <div className="font-serif-display text-3xl text-[#0A2E4D]">${Number(p.price).toLocaleString()}</div>
                {p.valid && <div className="text-[11px] text-[#9CA3AF] mt-1">{p.valid} · Terms apply</div>}
              </div>
              <Link to={`/flights?destination=${encodeURIComponent((p.route || "").split("→").pop().trim())}`}
                className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#0A2E4D] border-b-2 border-[#D4A62A] pb-1 self-start hover:gap-3 transition-all">
                Get My Best Fare <ArrowRight size={14} />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
